import { render, staticRenderFns } from "./MenuCheckpointToolbox.vue?vue&type=template&id=7237ba98&scoped=true&"
import script from "./MenuCheckpointToolbox.vue?vue&type=script&lang=js&"
export * from "./MenuCheckpointToolbox.vue?vue&type=script&lang=js&"
import style0 from "./MenuCheckpointToolbox.vue?vue&type=style&index=0&id=7237ba98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7237ba98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7237ba98')) {
      api.createRecord('7237ba98', component.options)
    } else {
      api.reload('7237ba98', component.options)
    }
    module.hot.accept("./MenuCheckpointToolbox.vue?vue&type=template&id=7237ba98&scoped=true&", function () {
      api.rerender('7237ba98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/MenuCheckpointToolbox.vue"
export default component.exports